import { Allergen } from '@eo-storefronts/eo-core'
import { Box, Tooltip } from '@mui/material'
import { useEoValue } from '~/src/hooks/useEoState'
import { LANGUAGE_STATE } from '~/src/stores/lang'

interface Props {
  allergen: Allergen,
}

const AllergenItem = ({ allergen }: Props) => {
  const lang = useEoValue(LANGUAGE_STATE)

  return (
    <Tooltip title={allergen.name[lang]}>
      <Box
        component='span'
        sx={{
          width: '25px',
          height: '25px',
          backgroundColor: 'background.contrastText',
          maskImage: `url('${allergen.image}')`,
          WebkitMaskImage: `url('${allergen.image}')`,
          maskPosition: 'center',
          WebkitMaskPosition: 'center',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat',
          maskSize: 'cover',
          WebkitMaskSize: 'cover'
        }}
        key={allergen.id}
      />
    </Tooltip>
  )
}

export default AllergenItem
